import {combineReducers} from 'redux';

import queryParamsReducer from 'common/reducers/query-params-reducer';

export default combineReducers({
  queryParams: queryParamsReducer,
});
